// techItems.js
import html from '../imgs/html.png';
import css from '../imgs/css.png';
import js from '../imgs/js.png';
import nodejs from '../imgs/nodejs.png';
import python from '../imgs/python.png';
import javascript from '../imgs/js.png';
import aws from '../imgs/aws.png';
import mongodb from '../imgs/mongodb.png';
import react from '../imgs/react.png';
import sql from '../imgs/sql.png';
import ticketmaster from '../imgs/ticketmaster.png';
import googleMaps from '../imgs/google-maps.png';
import express from '../imgs/express.png';
import amazonEC2 from '../imgs/amazonec2.png';
import amazonS3 from '../imgs/amazons3.jpg';
import sass from '../imgs/sass.png';
import firebase from '../imgs/firebase.png';
import typescript from '../imgs/typescript.png';
import wordpress from '../imgs/wordpress.png';
import youtube from '../imgs/youtube.png';
import tailwind from '../imgs/tailwind.png';
// TODO: Add these images to /src/imgs/
import gcp from '../imgs/gcp.png';
import gemini from '../imgs/gemini.png';
import swift from '../imgs/swift.png';
import kotlin from '../imgs/kotlin.png';
import stripe from '../imgs/stripe.png';
import shopify from '../imgs/shopify.png';
import vue from '../imgs/vue.png';
import flutter from '../imgs/flutter.png';
import docker from '../imgs/docker.png';

export const mostExperience = [
  { src: react, name: 'React.js' },
  { src: typescript, name: 'TypeScript' },
  { src: js, name: 'JavaScript' },
  { src: firebase, name: 'Firebase' },
  { src: gcp, name: 'GCP' },
  { src: nodejs, name: 'Node.js' },
  { src: tailwind, name: 'Tailwind CSS' },
];

export const quiteComfortable = [
  { src: react, name: 'React Native', className: 'special' },
  { src: vue, name: 'Vue' },
  { src: flutter, name: 'Flutter' },
  { src: mongodb, name: 'MongoDB' },
  { src: docker, name: 'Docker' },
  { src: python, name: 'Python' },
  { src: googleMaps, name: 'Google Maps API' },
  { src: ticketmaster, name: 'Ticketmaster API', className: 'lilRight' },
  { src: amazonEC2, name: 'Amazon EC2' },
  { src: amazonS3, name: 'Amazon S3' },
  { src: sql, name: 'SQL' },
];

export const meetup = [
  { src: react, name: 'React Native' },
  { src: swift, name: 'Swift' },
  { src: kotlin, name: 'Kotlin' },
  { src: mongodb, name: 'MongoDB' },
  { src: express, name: 'Express.js' },
  { src: nodejs, name: 'Node.js' },

];

export const chvenue = [
  { src: react, name: 'React.js' },
  { src: nodejs, name: 'Node.js' },
  { src: sass, name: 'Sass' },
]

export const EventsHereNow = [
  { src: html, name: 'HTML' },
  { src: css, name: 'CSS' },
  { src: javascript, name: 'JavaScript' },
  { src: firebase, name: 'Firebase' },
]

export const yardland = [
  { src: react, name: 'React.js' },
  { src: nodejs, name: 'Node.js' },
  { src: css, name: 'CSS' },
]

export const CRBC = [
  { src: wordpress, name: 'Wordpress CMS' },
  { src: youtube, name: 'Youtube Data API' },
  { src: react, name: 'React.js' },
  { src: nodejs, name: 'Node.js' },
  { src: css, name: 'CSS' },
]

export const mainStack = [
  { src: react, name: 'React.js' },
  { src: typescript, name: 'TypeScript' },
  { src: tailwind, name: 'Tailwind CSS' },
  { src: gcp, name: 'GCP' },
  { src: gemini, name: 'Gemini' },
]

export const toshiba = [
  { src: flutter, name: 'Flutter' },
  { src: kotlin, name: 'Kotlin' },
  { src: vue, name: 'Vue' },
  { src: mongodb, name: 'MongoDB' },
  { src: docker, name: 'Docker' },
]

export const valuable = [
  { src: react, name: 'React.js' },
  { src: typescript, name: 'TypeScript' },
  { src: firebase, name: 'Firebase' },
  { src: gcp, name: 'GCP' },
  { src: gemini, name: 'Gemini' },
  { src: swift, name: 'Swift' },
  { src: kotlin, name: 'Kotlin' },
  { src: stripe, name: 'Stripe' },
  { src: shopify, name: 'Shopify' },
]
